var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3751",
    "data-name": "Rectangle 3751",
    width: 24,
    height: 24,
    transform: "translate(-22345 12860)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4773",
    "data-name": "Mask Group 4773",
    transform: "translate(22345 -12860)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "supermarket",
    transform: "translate(-22342.199 12864.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8303",
    "data-name": "Path 8303",
    d: "M38.185,58.92l-.719-1.56A2.339,2.339,0,0,0,35.342,56H23.057a2.339,2.339,0,0,0-2.124,1.36l-.719,1.56A2.329,2.329,0,0,0,20,59.9a2.211,2.211,0,0,0,2.183,2.339A2.339,2.339,0,0,0,24.522,59.9a2.339,2.339,0,1,0,4.678,0,2.339,2.339,0,1,0,4.678,0,2.339,2.339,0,0,0,2.339,2.339A2.211,2.211,0,0,0,38.4,59.9,2.329,2.329,0,0,0,38.185,58.92Z",
    transform: "translate(-20 -56)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_822",
    "data-name": "Line 822",
    y2: 9.489,
    transform: "translate(1.559 6.104)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_823",
    "data-name": "Line 823",
    x2: 18.366,
    transform: "translate(0.033 15.84)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_824",
    "data-name": "Line 824",
    y1: 6.37,
    transform: "translate(16.84 6.104)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8304",
    "data-name": "Path 8304",
    d: "M140,302.237v-4.678A1.559,1.559,0,0,1,141.559,296h1.559a1.559,1.559,0,0,1,1.559,1.559v4.678",
    transform: "translate(-135.323 -286.645)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_825",
    "data-name": "Line 825",
    x2: 2.161,
    transform: "translate(11.917 10.439)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIconActive);
export default __webpack_public_path__ + "static/media/storeIconActive.f4cb184516d793a7a128e6689e8efb1a.svg";
export { ForwardRef as ReactComponent };